import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import MapService from "../services/MapService"

export const retrieve = createAsyncThunk(
    'map/retrieve',
    async (mapId, { getState, requestId }) => {
        const { currentRequestId, isLoading } = getState().map;

        if (isLoading !== true || requestId !== currentRequestId) {
            return;
        }
        var map = await MapService.retrieve(mapId);
        return map;
    }
);

export const createMap = createAsyncThunk(
    'map/createMap',
    async (data, { getState, requestId }) => {
        const { currentRequestId, isLoading } = getState().map;

        if (isLoading !== true || requestId !== currentRequestId) {
            return;
        }
        return await MapService.create();
    }
);

export const origin = [0, 0];
export const initialZoomLevel = 12;

const mapSlice = createSlice({
    name: 'map',
    initialState: {
        position: [0.00, 0.00],
        zoom: initialZoomLevel,
        geoJson: null,
        id: null,
        userId: null,
        isLoading: false,
        currentRequestId: undefined,
        error: null
    },
    reducers: {
        create(state, action) {
            state.geoJson = action.payload;
        },
        remove(state, action) {
            state.geoJson = action.payload;
        },
        edit(state, action) {
            state.geoJson = action.payload;
        },
        cut(state, action) {
            state.geoJson = action.payload;
        }
    },
    extraReducers: {
        [retrieve.pending]: (state, action) => {
            if (state.isLoading === false) {
                state.isLoading = true;
                state.currentRequestId = action.meta.requestId;
            }
        },
        [retrieve.fulfilled]: (state, action) => {
            const { requestId } = action.meta;
            if (state.isLoading === true && state.currentRequestId === requestId) {
                state.isLoading = false;
                state.geoJson = action.payload.geoJson;
                state.userId = action.payload.userId;
                state.currentRequestId = undefined;
            }
        },
        [retrieve.rejected]: (state, action) => {
            const { requestId } = action.meta;
            if (state.isLoading === true && state.currentRequestId === requestId) {
                state.isLoading = false;
                state.error = action.error;
                state.currentRequestId = undefined;
            }
        },
        [createMap.pending]: (state, action) => {
            if (state.isLoading === false) {
                state.isLoading = true;
                state.currentRequestId = action.meta.requestId;
            }
        },
        [createMap.fulfilled]: (state, action) => {
            const { requestId } = action.meta;
            if (state.isLoading === true && state.currentRequestId === requestId) {
                state.isLoading = false;
                state.id = action.payload.id;
                state.geoJson = action.payload.geoJson;
                state.userId = action.payload.userId;
                state.currentRequestId = undefined;
            }
        },
        [createMap.rejected]: (state, action) => {
            const { requestId } = action.meta;
            if (state.isLoading === true && state.currentRequestId === requestId) {
                state.isLoading = false;
                state.error = action.error;
                state.currentRequestId = undefined;
            }
        }
    }
});

export const { create, remove, edit, cut } = mapSlice.actions;

export default mapSlice.reducer;